export { ReactComponent as ClassicIcon_cn } from './ClassicIcon_cn.svg';
export { ReactComponent as ClassicIcon_en } from './ClassicIcon_en.svg';
export { ReactComponent as ClassicIcon_zh } from './ClassicIcon_zh.svg';
export { ReactComponent as ClosedTableIcon } from './ClosedTableIcon.svg';
export { ReactComponent as LanguageIcon } from './LanguageIcon.svg';
export { ReactComponent as NewTab } from './NewTab.svg';
export { ReactComponent as PlayerCountIcon } from './PlayerCountIcon.svg';
export { ReactComponent as ShuffleIcon } from './ShuffleIcon.svg';
export { ReactComponent as VoiceIcon } from './VoiceIcon.svg';